var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"video"}}),_c('transition',{attrs:{"name":"loader"}},[(_vm.loader)?_c('loader'):_vm._e()],1),_c('auth-modal'),_c('cart-modal'),_c('portal-target',{attrs:{"name":"terms"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }